import React from 'react';
import { Header } from "../presentation/Header";
import { Footer } from '../presentation/Footer';
import { ProductDetailLeft } from '../presentation/ProductDetailLeft';
import { Breadcrumb } from '../presentation/Breadcrumb';
import { ProductDetailRight } from '../presentation/ProductDetailRight';
import { ProductTab } from '../presentation/ProductTab';
import { RecentlyViewed } from '../presentation/RecentlyViewed';

export const Productdetail = () => {
  return (
    <>
      <Header />
      <Breadcrumb />
      <div className="lg:px-16 px-4 flex flex-col md:flex-row gap-10">
        <ProductDetailLeft />
        <ProductDetailRight />
      </div>
      <ProductTab />
      <RecentlyViewed />
      <Footer />
    </>
  )
}